import { useTranslation } from "react-i18next";

import Button from "@/components/button";
import { LeftArrow } from "@/components/icons";

export function EarningsDetailPanel({
  item,
  onBack,
  mode,
  label,
}: {
  item: any | null;
  onBack: () => void;
  mode: "worker" | "employer";
  label: string;
}) {
  const { t } = useTranslation("payments");
  if (!item) {
    return (
      <aside className="flex flex-col items-center justify-center h-full min-w-[320px] max-w-[400px] bg-white rounded-2xl shadow p-8 text-garnet/60">
        <span className="text-2xl mb-2">🪙</span>
        <div className="font-semibold text-lg mb-1">
          {t("sidebar.selectItem", { label: label.toLowerCase() })}
        </div>
        <div className="text-sm">{t("sidebar.chooseFromList")}</div>
      </aside>
    );
  }

  return (
    <aside className="min-w-[320px] flex flex-col max-w-[320px] bg-white rounded-2xl shadow p-8 gap-6">
    <Button variant="outline" className="w-[120px]" onClick={onBack}>
      <span className="flex items-center gap-[2px] w-full">
        <LeftArrow /> {t("navigation.back")}
      </span>
    </Button>
      <div className="flex items-center gap-4">
        <img
          src={mode === "worker" ? item.business_image : item.worker_avatar}
          alt="avatar"
          className="w-12 h-12 rounded-full bg-gray-100"
        />
        <div>
          <div className="font-bold text-garnet text-lg">
            {mode === "worker" ? item.business_name : item.worker_name}
          </div>
          <div className="text-xs text-garnet/70">{item.location || ""}</div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="text-garnet/70 text-sm">{t("detail.date")}</span>
          <span className="text-garnet font-medium">
            {new Date(item.created_at).toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
            })}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-garnet/70 text-sm">{t("detail.role")}</span>
          <span className="text-garnet font-medium">{item.role}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-garnet/70 text-sm">{t("detail.status")}</span>
          <span
            className={`font-bold ${item.payment_status === "completed" ? "text-green-600" : "text-yellow-600"}`}
          >
            {item.payment_status === "completed"
              ? t("detail.paid")
              : t("detail.pending")}
          </span>
        </div>
        <div className="flex items-center justify-between mt-2">
          <span className="text-garnet/70 text-sm">{t("detail.amount")}</span>
          <span className="text-garnet text-xl font-bold">
            ${item.payable.toFixed(2)}
          </span>
        </div>
      </div>
      {/* Add more breakdown fields here as needed */}
      <div className="mt-auto flex flex-col gap-2">
        <button className="w-full flex items-center justify-center gap-2 py-2 rounded-lg border border-gray-200 text-garnet font-medium">
          <span className="material-icons">download</span>
          {t("detail.downloadPayslip")}
        </button>
        <button className="w-full flex items-center justify-center gap-2 py-2 rounded-lg border border-gray-200 text-garnet font-medium">
          <span className="material-icons">report_problem</span>
          {t("detail.reportProblem")}
        </button>
        {mode === "worker" ? (
          <button className="w-full bg-gold text-garnet font-bold py-2 rounded-lg mt-2">
            {t("detail.withdrawEarnings")}
          </button>
        ) : null}
      </div>
    </aside>
  );
}
